export default "__VITE_ASSET__BVs$5fuK__"